import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface KsefConnectionResultDialogData {
  success: boolean;
  isAuthorized: boolean;
  permissions: string[];
  connectionType?: string;
  nip?: string;
  lastCheckAt?: string;
  lastError?: string;
  lastErrorAt?: string;
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  selector: 'app-ksef-connection-result-dialog',
  templateUrl: './ksef-connection-result-dialog.component.html'
})
export class KsefConnectionResultDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KsefConnectionResultDialogData,
    private dialogRef: MatDialogRef<KsefConnectionResultDialogComponent>
  ) {}

  translatePermission(permission: string): string {
    const translations: Record<string, string> = {
      'InvoiceWrite': 'Tworzenie faktur',
      'InvoiceRead': 'Odczyt faktur',
      'CredentialsRead': 'Odczyt uprawnień',
      'CredentialsManage': 'Zarządzanie uprawnieniami',
      'PaymentConfirmationWrite': 'Potwierdzanie płatności',
      'SelfInvoicing': 'Samofakturowanie',
      'TaxRepresentative': 'Przedstawiciel podatkowy',
      'Enforcement': 'Egzekucja',
      'SubjectRead': 'Odczyt podmiotów',
      'SubjectWrite': 'Tworzenie podmiotów',
      'Owner': 'Właściciel'
    };
    return translations[permission] || permission;
  }

  get isCertificateConnection(): boolean {
    return this.data.connectionType === 'CERTIFICATE';
  }

  private get hasOwner(): boolean {
    return this.data.permissions?.includes('Owner') || false;
  }

  hasInvoiceReadPermission(): boolean {
    if (this.hasOwner) return true;
    return this.data.permissions?.includes('InvoiceRead') || false;
  }

  hasInvoiceWritePermission(): boolean {
    if (this.hasOwner) return true;
    return this.data.permissions?.includes('InvoiceWrite') || false;
  }

  hasRequiredPermissions(): boolean {
    if (!this.data.permissions) return true; // Brak danych o uprawnieniach — nie pokazuj ostrzeżenia
    return this.hasInvoiceReadPermission() && this.hasInvoiceWritePermission();
  }

  close(): void {
    this.dialogRef.close();
  }
}
